var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "47px",
    viewBox: "0 0 24 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-23"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-24"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-26"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-27"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-28"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.800000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1D5BAA",
    x: 0,
    y: 0,
    width: 24,
    height: 47
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg0",
    transform: "translate(3.463409, 4.903255)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.989082, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.656847, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-3)",
    id: "c-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-4)",
    id: "c-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-5)",
    id: "c-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    id: "c",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-6)",
    id: "c-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    id: "c",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-7)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.561976, 0.924695)",
    filter: "url(#filter-8)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-9)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.131953, 3.411805)",
    filter: "url(#filter-10)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-11)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.040847, 6.887381)",
    filter: "url(#filter-12)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-13)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.131953, 10.362958)",
    filter: "url(#filter-14)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-15)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.561976, 12.850068)",
    filter: "url(#filter-16)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-17)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.989082, 13.774763)",
    filter: "url(#filter-18)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-19)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.478871, 12.850068)",
    filter: "url(#filter-20)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-21)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.908894, 10.362958)",
    filter: "url(#filter-22)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-23)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 6.887381)",
    filter: "url(#filter-24)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-25)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.908894, 3.411805)",
    filter: "url(#filter-26)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-27)",
    id: "s-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.478871, 0.924695)",
    filter: "url(#filter-28)",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.656847, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.908698, 1.048304) rotate(72.000000) translate(-1.908698, -1.048304) translate(1.163288, 0.348587)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.715254, 1.620846) rotate(144.000000) translate(-1.715254, -1.620846) translate(0.969845, 0.921129)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(1.089258, 1.626109) rotate(-144.000000) translate(-1.089258, -1.626109) translate(0.343849, 0.926392)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c-link",
    transform: "translate(0.895814, 1.056820) rotate(-72.000000) translate(-0.895814, -1.056820) translate(0.150405, 0.357103)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.838143, 0.699712) rotate(18.000000) translate(-0.838143, -0.699712) ",
    points: "0.554373377 0.126451126 0.545199264 1.27297233 1.13108695 1.26838528"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t-link",
    transform: "translate(0.652677, 0.699717) scale(-1, 1) translate(-0.652677, -0.699717) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "t",
    transform: "translate(0.652677, 0.699717) rotate(18.000000) translate(-0.652677, -0.699717) ",
    points: "0.368907423 0.126450866 0.359733326 1.27298271 0.945621014 1.2683956"
  })))))))), /*#__PURE__*/React.createElement("text", {
    id: "B",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: 18.0950815,
    fontWeight: "bold",
    letterSpacing: 0.115908435,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.22102332,
    y: 38.3133755
  }, "B"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate);
export default __webpack_public_path__ + "static/media/plate.39de890a2eaa131046fd0643dc8d6fb9.svg";
export { ForwardRef as ReactComponent };